import { useQuery, useQueryClient } from '@tanstack/react-query';
import { messagesApi } from '../lib/api';

// Item della lista "Da rispondere": messaggio marcato con reply_status='todo'.
export interface ToReplyItem {
  id: string;
  subject: string | null;
  from_name: string | null;
  from_address: string | null;
  received_at: string | null;
  reply_status?: 'todo' | 'done' | null;
}

// Hook lista "Da rispondere": carica i messaggi marcati come da rispondere.
// Stile allineato a useFeed (useQuery + queryFn difensiva sui wrapper della risposta).
export function useToReply() {
  return useQuery({
    queryKey: ['to-reply'],
    queryFn: async () => {
      const res = await messagesApi.listToReply();
      const items = res?.items ?? res?.messages ?? [];
      return items as ToReplyItem[];
    },
  });
}

// Helper per invalidare la lista "Da rispondere" dai componenti che la mutano.
export function useInvalidateToReply() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['to-reply'] });
}
